export const CreateCustomRoleApi = Symbol.for('CreateCustomRoleApi');
